import { render, staticRenderFns } from "./Instructors.html?vue&type=template&id=f5dd0f2a&external"
import script from "./Instructors.js?vue&type=script&lang=js&external"
export * from "./Instructors.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports